import { Card, css, Paper, styled, svgIconClasses } from '@mui/material';

export const StyledCurrentlySelectedContractPaper = styled(Paper)(
  ({ theme }) => css`
    background-color: ${theme.palette.background.info};
  `
);

export const StyledCurrentlySelectedContractCard = styled(Card)(
  ({ theme }) => css`
    background-color: ${theme.palette.background.info};
  `
);

export const StyledCurrentlySelectedContractCardContent = styled('div')(
  ({ theme }) => css`
    align-items: center;
    border-radius: 4px;
    column-gap: ${theme.spacing('LARGE')};
    display: flex;
    padding: ${theme.spacing('LARGE')};

    .${svgIconClasses.root}:first-of-type {
      height: ${theme.spacing('3XL')};
      width: ${theme.spacing('3XL')};
    }

    .${svgIconClasses.root}:nth-of-type(2) {
      height: ${theme.spacing('1XL')};
      width: ${theme.spacing('1XL')};
    }
  `
);

export const StyledCurrentlySelectedContractCardTextContent = styled('div')(
  ({ theme }) => css`
    column-gap: ${theme.spacing('LARGE')};
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    ${theme.breakpoints.up('desktop')} {
      flex-direction: row;
    }
  `
);
